<template>
  <page-content-toolbar :show-natural-language-switch="isAdvancedMode">
      <v-list-item-subtitle class="rai-menu-items">
        <v-breadcrumbs :items="steps" class="ma-0 pa-1">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
            :to="item.to"
            :disabled="item.disabled"
            >
            <span class="rai-menu-items">{{ $t(item.text) }}</span>
          </v-breadcrumbs-item>
        </template>
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-list-item-subtitle>
  </page-content-toolbar>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import userRightMixin from '@/mixins/user-rights-mixin.js';
import {UPDATE_SHOW_LOGICAL_LANGAGE} from '@/store/mutation-types';

export default {
  name: 'EditorStepper',

  components: {
    PageContentToolbar
  },

  mixins: [ userRightMixin ],

  computed: {
    showLogicalLangage: {
      get () {
        return this.$store.state.showLogicalLangage;
      },
      set (value) {
        this.$store.commit(UPDATE_SHOW_LOGICAL_LANGAGE, value);
      },
    },
    isAdvancedMode () {
      const result = this.$store.state.mode === 'advanced'
      if(!result) {
        this.$store.commit(UPDATE_SHOW_LOGICAL_LANGAGE, false);
      }
      return result
    },
  },

  props: {
    title: {
      type: String,
      required: false,
      default: '',
    }
  },

  data () {
    return {
      steps: [
      {
          text: 'editor.stepper.initialScenariosAndOptions',
          disabled: false,
          to: { name: 'editor', params: { projectId: this.$route.params.id } },
        },
        {
          text: 'editor.stepper.compatiblesScenarios',
          disabled: false,
          to: { name: 'compatiblesScenarios', params: { projectId: this.$route.params.id } },
        },
        {
          text: 'editor.stepper.conflicts',
          disabled: false,
          to: { name: 'conflictsResolution', params: { projectId: this.$route.params.id } }
        },
        {
          text: 'editor.stepper.decisionPolicy',
          disabled: false,
          to: { name: 'viewer', params: { projectId: this.$route.params.id } },
        },
      ]
    }
  },

  created () {
    this.getUserInfo();
  },
};
</script>
